export default {
  locale: process.env.DEFAULT_LOCALE,
  url: process.env.APP_URL,
  urlCN: process.env.APP_URL_CN,
  googleTagManagerKey: process.env.GOOGLE_TAG_MANAGER_KEY,
  apiUrl: process.env.API_URL,
  apiUrlCN: process.env.API_URL_CN,
}
